<!-- 图片广告 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <div>
                <Menu
                    mode="horizontal"
                    :active-name="name_id"
                    @on-select="selectName"
                >
                    <MenuItem name="1" class="head-text">图片样式</MenuItem>
                    <MenuItem name="2" class="head-text">图片设置</MenuItem>
                    <MenuItem name="3" class="head-text">边距设置</MenuItem>
                </Menu>
                <div class="mt24 mb24">
                    <div v-if="name_id == 1">
                        <div class="style-divs">
                            <div
                                class="style-div"
                                v-for="(item, index) in imgStyleList"
                                :key="index"
                                :class="
                                    newFormData.content.style_id == index
                                        ? 'style-active'
                                        : 'style-default'
                                "
                                @click="changeStyle(index, item)"
                            >
                                <img
                                    class="style-img"
                                    :src="
                                        newFormData.content.style_id == index
                                            ? item.img_active
                                            : item.img
                                    "
                                />
                                <span>{{ item.text }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="name_id == 2">
                        <Form
                            :model="newFormData"
                            label-position="right"
                            :label-width="80"
                        >
                            <div class="form-title">图片上传</div>
                            <FormItem label="点击预览">
                                <i-switch
                                    v-model="newFormData.content.preview_value"
                                    size="large"
                                    true-color="#FF761D "
                                    :true-value="1"
                                    :false-value="0"
                                    @on-change="changePreviewValue"
                                >
                                    <span slot="open">开启</span>
                                    <span slot="close">关闭</span>
                                </i-switch>
                            </FormItem>
                            <FormItem label="图片"></FormItem>
                            <!-- 1张图 -->
                            <div
                                v-if="newFormData.content.style_id == 0"
                                class="upload-div"
                                @click="openModal(0)"
                            >
                                <img
                                    class="wh100"
                                    v-if="
                                        newFormData.content.imgList[0].picview
                                    "
                                    :src="
                                        newFormData.content.imgList[0].picview
                                    "
                                />
                                <div v-else class="upload-none"></div>
                                <div class="upload-icon">
                                    <div class="flex-c flex-column">
                                        <Icon
                                            type="md-add"
                                            size="50"
                                            color="#ccc"
                                        />
                                        <div>宽度建议780px或其倍数</div>
                                    </div>
                                </div>
                            </div>
                            <!-- 2张图 -->
                            <div
                                v-if="newFormData.content.style_id == 1"
                                class="upload-container dis-flex"
                            >
                                <div class="box w33" @click="openModal(0)">
                                    <img
                                        class="wh100"
                                        v-if="
                                            newFormData.content.imgList[0]
                                                .picview
                                        "
                                        :src="
                                            newFormData.content.imgList[0]
                                                .picview
                                        "
                                    />
                                    <div class="wh100" v-else></div>
                                    <div class="upload-icon">
                                        <div class="flex-c flex-column">
                                            <Icon
                                                type="md-add"
                                                size="50"
                                                color="#ccc"
                                            />
                                            <div>260*520px</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="box w66" @click="openModal(1)">
                                    <img
                                        class="wh100"
                                        v-if="
                                            newFormData.content.imgList[1]
                                                .picview
                                        "
                                        :src="
                                            newFormData.content.imgList[1]
                                                .picview
                                        "
                                    />
                                    <div class="wh100" v-else></div>
                                    <div class="upload-icon">
                                        <div class="flex-c flex-column">
                                            <Icon
                                                type="md-add"
                                                size="50"
                                                color="#ccc"
                                            />
                                            <div>520*520px</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 3张图 -->
                            <div
                                v-if="newFormData.content.style_id == 2"
                                class="upload-container dis-flex"
                            >
                                <div class="box w33" @click="openModal(0)">
                                    <img
                                        class="wh100"
                                        v-if="
                                            newFormData.content.imgList[0]
                                                .picview
                                        "
                                        :src="
                                            newFormData.content.imgList[0]
                                                .picview
                                        "
                                    />
                                    <div class="wh100" v-else></div>
                                    <div class="upload-icon">
                                        <div class="flex-c flex-column">
                                            <Icon
                                                type="md-add"
                                                size="50"
                                                color="#ccc"
                                            />
                                            <div>260*520px</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="w66">
                                    <div class="box h50" @click="openModal(1)">
                                        <img
                                            class="wh100"
                                            v-if="
                                                newFormData.content.imgList[1]
                                                    .picview
                                            "
                                            :src="
                                                newFormData.content.imgList[1]
                                                    .picview
                                            "
                                        />
                                        <div class="wh100" v-else></div>
                                        <div class="upload-icon">
                                            <div class="flex-c flex-column">
                                                <Icon
                                                    type="md-add"
                                                    size="50"
                                                    color="#ccc"
                                                />
                                                <div>520*260px</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="box h50" @click="openModal(2)">
                                        <img
                                            class="wh100"
                                            v-if="
                                                newFormData.content.imgList[2]
                                                    .picview
                                            "
                                            :src="
                                                newFormData.content.imgList[2]
                                                    .picview
                                            "
                                        />
                                        <div class="wh100" v-else></div>
                                        <div class="upload-icon">
                                            <div class="flex-c flex-column">
                                                <Icon
                                                    type="md-add"
                                                    size="50"
                                                    color="#ccc"
                                                />
                                                <div>520*260px</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 4张图 -->
                            <div
                                v-if="newFormData.content.style_id == 3"
                                class="upload-container dis-flex"
                            >
                                <div class="box w33" @click="openModal(0)">
                                    <img
                                        class="wh100"
                                        v-if="
                                            newFormData.content.imgList[0]
                                                .picview
                                        "
                                        :src="
                                            newFormData.content.imgList[0]
                                                .picview
                                        "
                                    />
                                    <div class="wh100" v-else></div>
                                    <div class="upload-icon">
                                        <div class="flex-c flex-column">
                                            <Icon
                                                type="md-add"
                                                size="50"
                                                color="#ccc"
                                            />
                                            <div>260*520px</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="w66">
                                    <div class="box h50" @click="openModal(1)">
                                        <img
                                            class="wh100"
                                            v-if="
                                                newFormData.content.imgList[1]
                                                    .picview
                                            "
                                            :src="
                                                newFormData.content.imgList[1]
                                                    .picview
                                            "
                                        />
                                        <div class="wh100" v-else></div>
                                        <div class="upload-icon">
                                            <div class="flex-c flex-column">
                                                <Icon
                                                    type="md-add"
                                                    size="50"
                                                    color="#ccc"
                                                />
                                                <div>520*260px</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="h50 flex-c">
                                        <div
                                            class="box w-h-100"
                                            @click="openModal(2)"
                                        >
                                            <img
                                                class="wh100"
                                                v-if="
                                                    newFormData.content
                                                        .imgList[2].picview
                                                "
                                                :src="
                                                    newFormData.content
                                                        .imgList[2].picview
                                                "
                                            />
                                            <div class="wh100" v-else></div>
                                            <div class="upload-icon">
                                                <div class="flex-c flex-column">
                                                    <Icon
                                                        type="md-add"
                                                        size="50"
                                                        color="#ccc"
                                                    />
                                                    <div>260*260px</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="box w-h-100"
                                            @click="openModal(3)"
                                        >
                                            <img
                                                class="wh100"
                                                v-if="
                                                    newFormData.content
                                                        .imgList[3].picview
                                                "
                                                :src="
                                                    newFormData.content
                                                        .imgList[3].picview
                                                "
                                            />
                                            <div class="wh100" v-else></div>
                                            <div class="upload-icon">
                                                <div class="flex-c flex-column">
                                                    <Icon
                                                        type="md-add"
                                                        size="50"
                                                        color="#ccc"
                                                    />
                                                    <div>260*260px</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 2张图平分 -->
                            <div
                                v-if="newFormData.content.style_id == 4"
                                class="upload-container dis-flex"
                            >
                                <div class="box w50" @click="openModal(0)">
                                    <img
                                        class="wh100"
                                        v-if="
                                            newFormData.content.imgList[0]
                                                .picview
                                        "
                                        :src="
                                            newFormData.content.imgList[0]
                                                .picview
                                        "
                                    />
                                    <div class="wh100" v-else></div>
                                    <div class="upload-icon">
                                        <div class="flex-c flex-column">
                                            <Icon
                                                type="md-add"
                                                size="50"
                                                color="#ccc"
                                            />
                                            <div>390*520px</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="box w50" @click="openModal(1)">
                                    <img
                                        class="wh100"
                                        v-if="
                                            newFormData.content.imgList[1]
                                                .picview
                                        "
                                        :src="
                                            newFormData.content.imgList[1]
                                                .picview
                                        "
                                    />
                                    <div class="wh100" v-else></div>
                                    <div class="upload-icon">
                                        <div class="flex-c flex-column">
                                            <Icon
                                                type="md-add"
                                                size="50"
                                                color="#ccc"
                                            />
                                            <div>390*520px</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 3张图平分 -->
                            <div
                                v-if="newFormData.content.style_id == 5"
                                class="upload-container dis-flex"
                            >
                                <div class="box w33" @click="openModal(0)">
                                    <img
                                        class="wh100"
                                        v-if="
                                            newFormData.content.imgList[0]
                                                .picview
                                        "
                                        :src="
                                            newFormData.content.imgList[0]
                                                .picview
                                        "
                                    />
                                    <div class="wh100" v-else></div>
                                    <div class="upload-icon">
                                        <div class="flex-c flex-column">
                                            <Icon
                                                type="md-add"
                                                size="50"
                                                color="#ccc"
                                            />
                                            <div>260*520px</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="box w33" @click="openModal(1)">
                                    <img
                                        class="wh100"
                                        v-if="
                                            newFormData.content.imgList[1]
                                                .picview
                                        "
                                        :src="
                                            newFormData.content.imgList[1]
                                                .picview
                                        "
                                    />
                                    <div class="wh100" v-else></div>
                                    <div class="upload-icon">
                                        <div class="flex-c flex-column">
                                            <Icon
                                                type="md-add"
                                                size="50"
                                                color="#ccc"
                                            />
                                            <div>260*520px</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="box w33" @click="openModal(2)">
                                    <img
                                        class="wh100"
                                        v-if="
                                            newFormData.content.imgList[2]
                                                .picview
                                        "
                                        :src="
                                            newFormData.content.imgList[2]
                                                .picview
                                        "
                                    />
                                    <div class="wh100" v-else></div>
                                    <div class="upload-icon">
                                        <div class="flex-c flex-column">
                                            <Icon
                                                type="md-add"
                                                size="50"
                                                color="#ccc"
                                            />
                                            <div>260*520px</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 4张左右平分 -->
                            <div
                                v-if="newFormData.content.style_id == 6"
                                class="upload-container dis-flex"
                            >
                                <div class="box w25" @click="openModal(0)">
                                    <img
                                        class="wh100"
                                        v-if="
                                            newFormData.content.imgList[0]
                                                .picview
                                        "
                                        :src="
                                            newFormData.content.imgList[0]
                                                .picview
                                        "
                                    />
                                    <div class="wh100" v-else></div>
                                    <div class="upload-icon">
                                        <div class="flex-c flex-column">
                                            <Icon
                                                type="md-add"
                                                size="50"
                                                color="#ccc"
                                            />
                                            <div>195*520px</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="box w25" @click="openModal(1)">
                                    <img
                                        class="wh100"
                                        v-if="
                                            newFormData.content.imgList[1]
                                                .picview
                                        "
                                        :src="
                                            newFormData.content.imgList[1]
                                                .picview
                                        "
                                    />
                                    <div class="wh100" v-else></div>
                                    <div class="upload-icon">
                                        <div class="flex-c flex-column">
                                            <Icon
                                                type="md-add"
                                                size="50"
                                                color="#ccc"
                                            />
                                            <div>195*520px</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="box w25" @click="openModal(2)">
                                    <img
                                        class="wh100"
                                        v-if="
                                            newFormData.content.imgList[2]
                                                .picview
                                        "
                                        :src="
                                            newFormData.content.imgList[2]
                                                .picview
                                        "
                                    />
                                    <div class="wh100" v-else></div>
                                    <div class="upload-icon">
                                        <div class="flex-c flex-column">
                                            <Icon
                                                type="md-add"
                                                size="50"
                                                color="#ccc"
                                            />
                                            <div>195*520px</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="box w25" @click="openModal(3)">
                                    <img
                                        class="wh100"
                                        v-if="
                                            newFormData.content.imgList[3]
                                                .picview
                                        "
                                        :src="
                                            newFormData.content.imgList[3]
                                                .picview
                                        "
                                    />
                                    <div class="wh100" v-else></div>
                                    <div class="upload-icon">
                                        <div class="flex-c flex-column">
                                            <Icon
                                                type="md-add"
                                                size="50"
                                                color="#ccc"
                                            />
                                            <div>195*520px</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 4张上下平分 -->
                            <div
                                v-if="newFormData.content.style_id == 7"
                                class="upload-container dis-flex"
                            >
                                <div class="w50">
                                    <div class="box h50" @click="openModal(0)">
                                        <img
                                            class="wh100"
                                            v-if="
                                                newFormData.content.imgList[0]
                                                    .picview
                                            "
                                            :src="
                                                newFormData.content.imgList[0]
                                                    .picview
                                            "
                                        />
                                        <div class="wh100" v-else></div>
                                        <div class="upload-icon">
                                            <div class="flex-c flex-column">
                                                <Icon
                                                    type="md-add"
                                                    size="50"
                                                    color="#ccc"
                                                />
                                                <div>390*260px</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="box h50" @click="openModal(2)">
                                        <img
                                            class="wh100"
                                            v-if="
                                                newFormData.content.imgList[2]
                                                    .picview
                                            "
                                            :src="
                                                newFormData.content.imgList[2]
                                                    .picview
                                            "
                                        />
                                        <div class="wh100" v-else></div>
                                        <div class="upload-icon">
                                            <div class="flex-c flex-column">
                                                <Icon
                                                    type="md-add"
                                                    size="50"
                                                    color="#ccc"
                                                />
                                                <div>390*260px</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="w50">
                                    <div class="box h50" @click="openModal(1)">
                                        <img
                                            class="wh100"
                                            v-if="
                                                newFormData.content.imgList[1]
                                                    .picview
                                            "
                                            :src="
                                                newFormData.content.imgList[1]
                                                    .picview
                                            "
                                        />
                                        <div class="wh100" v-else></div>
                                        <div class="upload-icon">
                                            <div class="flex-c flex-column">
                                                <Icon
                                                    type="md-add"
                                                    size="50"
                                                    color="#ccc"
                                                />
                                                <div>390*260px</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="box h50" @click="openModal(3)">
                                        <img
                                            class="wh100"
                                            v-if="
                                                newFormData.content.imgList[3]
                                                    .picview
                                            "
                                            :src="
                                                newFormData.content.imgList[3]
                                                    .picview
                                            "
                                        />
                                        <div class="wh100" v-else></div>
                                        <div class="upload-icon">
                                            <div class="flex-c flex-column">
                                                <Icon
                                                    type="md-add"
                                                    size="50"
                                                    color="#ccc"
                                                />
                                                <div>390*260px</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-title">热区划分</div>
                            <FormItem label="热区">
                                <Button @click="openDialog">{{
                                    newFormData.content.hotspot.length
                                        ? "已划分"
                                        : hopsot_name
                                }}</Button>
                                <hotSpot
                                    v-if="dialog_modal"
                                    :dialog_modal.sync="dialog_modal"
                                    :formData="newFormData"
                                    :actionList="actionList"
                                    :linkList="linkList"
                                    @updateHotspot="updateHotspot"
                                ></hotSpot>
                            </FormItem>
                        </Form>
                    </div>
                    <div v-if="name_id == 3">
                        <Form
                            :model="newFormData"
                            label-position="right"
                            :label-width="80"
                        >
                            <div class="form-title">外间距</div>
                            <FormItem label="上下间距"
                                ><Slider
                                    v-if="newFormData.content.marginData"
                                    class="w300"
                                    show-input
                                    v-model="newFormData.content.marginData.top"
                                ></Slider
                            ></FormItem>
                            <FormItem label="左右间距"
                                ><Slider
                                    v-if="newFormData.content.marginData"
                                    class="w300"
                                    show-input
                                    v-model="
                                        newFormData.content.marginData.left
                                    "
                                ></Slider
                            ></FormItem>
                            <div class="form-title">圆角设置</div>
                            <FormItem label="上圆角"
                                ><Slider
                                    v-if="newFormData.content.radiusData"
                                    class="w300"
                                    show-input
                                    v-model="newFormData.content.radiusData.top"
                                ></Slider
                            ></FormItem>
                            <FormItem label="下圆角"
                                ><Slider
                                    v-if="newFormData.content.radiusData"
                                    class="w300"
                                    show-input
                                    v-model="
                                        newFormData.content.radiusData.bottom
                                    "
                                ></Slider
                            ></FormItem>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
import hotSpot from "@/components/hotSpot/hotSpot.vue";
export default {
    components: {
        pictureLibrary,
        hotSpot,
    },
    props: {
        diy_id: {
            type: String,
            default: "0",
        },
        newFormData: {
            type: Object,
            default: {},
        },
        linkList: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
            actionList: [],
            imgStyleList: [
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/1-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/1-2.png",
                    text: "1张图",
                    num: 1,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/2-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/2-2.png",
                    text: "2张图",
                    num: 2,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/3-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/3-2.png",
                    text: "3张图",
                    num: 3,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/4-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/4-2.png",
                    text: "4张图",
                    num: 4,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/5-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/5-2.png",
                    text: "2张图平分",
                    num: 2,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/6-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/6-2.png",
                    text: "3张图平分",
                    num: 3,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/7-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/7-2.png",
                    text: "4张左右平分",
                    num: 4,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/8-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/8-2.png",
                    text: "4张上下平分",
                    num: 4,
                },
            ],
            hopsot_name: "划分热区",
            dialog_modal: false,
            upload_id: 0,
        };
    },
    mounted() {
        if (this.diy_id == 1) {
            this.actionList = [
                { id: 1, name: "跳转外部链接" },
                { id: 2, name: "跳转页面" },
                { id: 3, name: "扫一扫" },
            ];
        } else if (this.diy_id == 2) {
            this.actionList = [
                { id: 1, name: "跳转外部链接" },
                { id: 3, name: "扫一扫" },
            ];
        }
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.upload_id == 0) {
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.imgList[0].picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.imgList[0].value = param2[i];
                }
                this.$Message.destroy();
            } else if (this.upload_id == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.imgList[1].picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.imgList[1].value = param2[i];
                }
                this.$Message.destroy();
            } else if (this.upload_id == 2) {
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.imgList[2].picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.imgList[2].value = param2[i];
                }
                this.$Message.destroy();
            } else if (this.upload_id == 3) {
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.imgList[3].picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.imgList[3].value = param2[i];
                }
                this.$Message.destroy();
            }
        },
        openModal(i) {
            this.upload_id = i;
            this.switch_modal = true;
        },
        selectName(name) {
            this.name_id = name;
        },
        // 删除图片
        delImageStyle(e) {
            this.newFormData.content.imgList[e].value = "";
            this.newFormData.content.imgList[e].picview = "";
        },
        changeStyle(index, item) {
            this.newFormData.content.style_id = index;
            this.newFormData.content.hotspot = [];
            this.newFormData.content.imgList = [];
            for (let i = 0; i < item.num; i++) {
                this.newFormData.content.imgList.push({
                    value: "",
                    picview: "",
                });
            }
        },
        openDialog() {
            this.dialog_modal = true;
            this.$forceUpdate();
        },
        updateHotspot(e) {
            var newFormData = e;
            if (
                typeof newFormData.content.hotspot == "undefined" ||
                newFormData.content.hotspot.length == 0
            ) {
                this.hopsot_name = "划分热区";
            } else {
                this.hopsot_name = "已划分";
            }
        },
        changePreviewValue(e) {
            this.newFormData.content.preview_value = e;
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.style-active {
    border: 1px solid #ff761d;
    color: #ff761d;
}
.style-default {
    border: 1px solid #dadada;
    color: #333333;
}
.style-divs {
    padding: 12px 0 0 12px;
    border: 1px solid #dadada;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.style-div {
    margin: 0 12px 12px 0;
    width: 100px;
    height: 100px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.style-img {
    width: 80px;
}
.upload-container {
    width: 390px;
    height: 260px;
    border: 1px solid #9fa5bb;
    position: relative;
}
.upload-div {
    width: 390px;
    height: 260px;
    border: 1px solid #9fa5bb;
    position: relative;
    cursor: pointer;
    height: auto;
}
.upload-none {
    height: 260px;
}
.upload-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
}
.w-h-100 {
    width: 100%;
    height: 100%;
}
.wh100 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
.box {
    position: relative;
    border: 1px solid #9fa5bb;
    cursor: pointer;
}
.w33 {
    width: 33.333%;
}
.w66 {
    width: 66.666%;
}
.dis-flex {
    display: flex;
}
.h50 {
    height: 50%;
}
.w50 {
    width: 50%;
}
.w25 {
    width: 25%;
}
.flex-column {
    flex-direction: column !important;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
</style>